/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const weekDaySchema = z.object({
  day: z.string(),
  date: z.string(),
  completed: z.boolean(),
  isToday: z.boolean(),
});

export type IWeekDay = z.infer<typeof weekDaySchema>;
